import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Search, ArrowLeft } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Button } from '@/components/ui/button';

const NotFound = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />

      <div className="flex-1 flex items-center justify-center px-4 py-16" data-testid="not-found-page">
        <div className="text-center max-w-md">
          <p
            className="text-8xl sm:text-9xl font-bold text-primary/15 leading-none select-none"
            style={{ fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, \'Segoe UI\', sans-serif' }}
          >
            404
          </p>
          <h1
            className="text-2xl sm:text-3xl font-bold mt-4 mb-3 tracking-tight"
            style={{ fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, \'Segoe UI\', sans-serif' }}
            data-testid="not-found-title"
          >
            Página no encontrada
          </h1>
          <p className="text-sm sm:text-base text-muted-foreground mb-8">
            La página que buscas no existe o fue movida. Explora nuestras propiedades o regresa al inicio.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link to="/">
              <Button className="w-full sm:w-auto" data-testid="go-home-btn">
                <Home className="w-4 h-4 mr-2" />
                Ir al Inicio
              </Button>
            </Link>
            <Link to="/search">
              <Button variant="outline" className="w-full sm:w-auto" data-testid="go-search-btn">
                <Search className="w-4 h-4 mr-2" />
                Buscar Propiedades
              </Button>
            </Link>
          </div>

          <button
            onClick={() => window.history.back()}
            className="mt-6 inline-flex items-center text-sm text-muted-foreground hover:text-foreground transition-colors"
            data-testid="go-back-btn"
          >
            <ArrowLeft className="w-4 h-4 mr-1" />
            Volver atrás
          </button>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default NotFound;
